<template>
  <div class="wrapper main-container">
    <!-- 业务员产品 -->
    <div style="overflow:hidden">
      <div class="lf">请输入一个业务员姓名来获取ta的专属投保链接</div>
      <Button class="rf" type="primary" ghost @click="$router.go(-1)">返回</Button>
    </div>
    <Form :inline="true" ref="formRef" :model="searchParams" :label-width="80" class="search-box one-btn min">
      <FormItem label="机构/团队">
        <selectTree v-model="searchParams.applyOrgId" @change="selectTreeChange" type="child" :isAll="true"></selectTree>
      </FormItem>
      <FormItem label="业务员姓名">
        <Input v-model="searchParams.userName" placeholder="请输入" clearable/>
      </FormItem>
      <div class="btn-item">
        <Button type="primary" @click="search()">查询</Button>
      </div>
    </Form>
    <loading :isShow="listLoading" />
    <div class="table-box">
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row, index }" slot="copyUrl">
          <div style="width:100%;position:relative;" v-if="row.insureUrl">
            <a :class="{'disabled':row.enableFlag!=1||row.qualificationFlag!=1}" @click="copyLink(row.insureUrl,index)">
                <input
                  class="insureUrl_target"
                  style="position:absolute;top:-1000000000000px"
                  :value="row.insureUrl"
                  type="text"/>
                复制链接
            </a>
            <Poptip
                  style="position: absolute;"
                  trigger="hover"
                  content="content"
                  :transfer="true"
                  transfer-class-name="channelQrcode"
                  v-if="row.orgStatus==2||row.workingState==0||row.isSus==1||row.qualificationFlag!=1"
                >
              <span class="wenhao">?</span>
              <div slot="content">
                <span v-if="row.orgStatus==2">此机构已停业，业务员暂不支持投保</span>
                <span v-else-if="row.workingState==0">业务员已离职，暂不支持投保</span>
                <span v-else-if="row.isSus==1">业务员已停职，暂不支持投保</span>
                <span v-else-if="row.qualificationFlag!=1">业务员执业资格未认证，暂不支持投保</span>
              </div>
            </Poptip>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="veuqr">
          <div style="width:100%;position:relative;" v-if="row.insureUrl">
            <Poptip
            :class="{'disabled':row.enableFlag!=1||row.qualificationFlag!=1}"
              trigger="hover"
              content="content"
              :transfer="true"
              transfer-class-name="channelQrcode"
            >
              <a @click="downLoad(row._index,row)" :class="{'disabled':row.enableFlag!=1||row.qualificationFlag!=1}">
                下载二维码
              </a>
              <div slot="content">
                <vueQr :text="row.insureUrl" :size="120" :margin="0" />
              </div>
            </Poptip>
            <Poptip
                  style="position: absolute;"
                  trigger="hover"
                  content="content"
                  :transfer="true"
                  transfer-class-name="channelQrcode"
                  v-if="row.orgStatus==2||row.workingState==0||row.isSus==1||row.qualificationFlag!=1"
                >
              <span class="wenhao">?</span>
              <div slot="content">
                <span v-if="row.orgStatus==2">此机构已停业，业务员暂不支持投保</span>
                <span v-else-if="row.workingState==0">业务员已离职，暂不支持投保</span>
                <span v-else-if="row.isSus==1">业务员已停职，暂不支持投保</span>
                <span v-else-if="row.qualificationFlag!=1">业务员执业资格未认证，暂不支持投保</span>
              </div>
            </Poptip>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <div class="detail">
            <div @click="showAllInfoMask(row)">
              <span class="icon icon-edit"></span>
              <span>编辑</span>
            </div>
            <div @click="toDeleteOrganization(row)">
              <span class="icon icon-remove"></span>
              <span>删除</span>
            </div>
          </div>
        </template>
      </Table>
    </div>
    <div class="pageBox" style="margin-top:20px;">
      <Page
        :total="total"
        :current.sync="pageNum"
        :page-size="pageSize"
        show-total
        @on-change="getList"
        style="text-align: center"
      />
    </div>
  </div>
</template>

<script>
import vueQr from "vue-qr";
import selectTree from "@/components/system/selectTree";
import {pageTool} from "@/api/mixins";
export default {
  mixins:[pageTool],
  components: {
    selectTree,
    vueQr
  },
  props: {},
  data() {
    return {
      searchParams:{
      },
      total: 0,
      pageNo: 1,
      pageSize: 10,
      isChannel: false,//是否应用业务员链接
      columns: []
    };
  },
  watch: {},
  computed: {},
  created() {},
  async mounted() {
    const insureType = this.$route.query.insureType
    if(insureType && !insureType.includes('1') && (insureType.includes('2')||insureType.includes('6'))){
      this.isChannel = true;
    }else{
      this.isChannel = false;
    }
    this.initColumn();
    this.searchParams.productCode = this.$route.query.productCode;
    this.initListAjax("/buz/userBase/queryUserProduct");
  },
  methods: {
    //复制链接
    copyLink(url, index) {
      const target = document.querySelectorAll(".insureUrl_target");
      target[index].select();
      document.execCommand("Copy");
      this.$Message.success("复制成功");
    },
    //下载图片
    downLoad(index, item) {
      const outer = document.querySelectorAll(".channelQrcode");
      var url = outer[index].querySelector("img").src;
      var a = document.createElement("a");
      var event = new MouseEvent("click");
      // 下载图名字
      a.download = item.productName;
      a.href = url;
      // 合成函数，执行下载
      a.dispatchEvent(event);
    },
    // 组织选择
    selectTreeChange(data) {
      if (data.nodeType == 1) {//机构
        this.searchParams.organizationId = data.id;
        this.searchParams.groupId = "";
      } else if (data.nodeType == 2) {//团队
        this.searchParams.organizationId = "";
        this.searchParams.groupId = data.id;
      }else{
        this.searchParams.organizationId = "";
        this.searchParams.groupId = "";
      }
    },
    search(){
      this.$refs.formRef.validate().then(isok=>{
        if(isok){
          this.searchAjax();
        }
      })
    },
    setListParams(params) {
      this.listLoading = true;
      params.queryType = 1;
      params.isGift = this.$route.query.isGift;
      this.listUrl = "/buz/userBase/queryUserProduct";
    },
    listCallback(resData){
      if(this.isChannel){
        resData.data.forEach(item=>{
          item.insureUrl = item.insureUrl.replace('/product/','/product/app/')
        })
      }
    },
    initColumn() {
      const vm = this;
      this.columns = [
        {
          title: "业务员姓名",
          key: "userName",
          align: "center"
        },
        {
          title: "所属机构",
          key: "organizationName",
          align: "center",
          minWidth: 200,
        },

        {
          title: "所属团队",
          key: "groupName",
          align: "center",
          minWidth: 200,
        },
        {
          title: "产品名称",
          key: "productName",
          align: "center",
          minWidth: 230,
        },
        {
          title: "投保链接",
          align: "center",
          slot:'copyUrl',
        },
        {
          title: "投保二维码",
          key: "leaderName",
          align: "center",
          slot:'veuqr'
        }
      ];
    }
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  .search-box {
    margin-bottom: 15px;
  }
  /deep/ .ivu-col {
    width: 402px;
  }
  .lf {
    float: left;
  }
  .rf {
    float: right;
  }
  .searchBox {
    display: flex;
    /deep/ .ivu-form .ivu-form-item-label {
      text-align: left;
    }
    /deep/ .ivu-form-item-content {
      margin-right: 30px;
    }
    .left {
      float: left;
      width: 100%;
    }
    .right {
      float: right;
      /deep/ .ivu-btn {
        width: 80px;
        height: 30px;
        margin-top: 15px;
      }
    }
  }

  .disabled{
    filter: grayscale(1);
    pointer-events: none;
  }
  .wenhao{
    margin-left: 3px;
    width: 15px;
    height: 15px;
    border-radius: 15px;
    background: transparent;
    border: 1px solid #ccc;
    color: #ccc;
    display: inline-block;
    text-align: center;
    line-height:14px;
    font-size: 14px;
    cursor: pointer;
    top:50%;
}
.tableBox{
    &/deep/.ivu-table-cell-slot{
      width: 100%;
    }
  }
}
</style>
